package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.border
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.model.UserProfile
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource

@Composable
fun UserCard(
    user: UserProfile,
    isFollowing: Boolean,
    onFollow: () -> Unit,
    onUnfollow: () -> Unit,
    onOpenProfile: () -> Unit = {}
) {

    var isLoading by remember { mutableStateOf(false) }

    LaunchedEffect(isFollowing) {
        isLoading = false
    }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 6.dp)
            .clip(RoundedCornerShape(18.dp))
            .background(BrandColors.Card)
            .border(1.dp, Color(0xFF2A2A2E), RoundedCornerShape(18.dp))
            .clickable { onOpenProfile() }
            .padding(16.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {

        Box(
            modifier = Modifier
                .size(56.dp)
                .clip(CircleShape)
                .background(BrandColors.Secondary),
            contentAlignment = Alignment.Center
        ) {

            val avatarUrl = user.avatarUrl.ifBlank { null }

            if (avatarUrl != null) {

                KamelImage(
                    resource = asyncPainterResource(avatarUrl),
                    contentDescription = "Avatar",
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.fillMaxSize()
                )

            } else {

                Text(
                    text = user.username
                        .take(1)
                        .uppercase(),
                    color = Color.White,
                    fontWeight = FontWeight.Bold
                )
            }
        }

        Spacer(modifier = Modifier.width(14.dp))

        Column(
            modifier = Modifier.weight(1f)
        ) {

            Text(
                text = user.username,
                color = Color.White,
                fontWeight = FontWeight.Bold
            )

            Text(
                text = "Level ${user.level}",
                color = Color.Gray
            )
        }

        if (isFollowing) {

            OutlinedButton(
                onClick = {
                    if (isLoading) return@OutlinedButton
                    isLoading = true
                    onUnfollow()
                },
                shape = RoundedCornerShape(16.dp),
                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.6f))
            ) {

                if (isLoading) {

                    CircularProgressIndicator(
                        modifier = Modifier.size(16.dp),
                        strokeWidth = 2.dp,
                        color = Color.White
                    )

                } else {

                    Text(
                        text = "Following",
                        color = Color.White,
                        fontWeight = FontWeight.Bold
                    )
                }
            }

        } else {

            Button(
                onClick = {
                    if (isLoading) return@Button
                    isLoading = true
                    onFollow()
                },
                shape = RoundedCornerShape(16.dp),
                colors = ButtonDefaults.buttonColors(
                    containerColor = BrandColors.Secondary,
                    contentColor = Color.White
                )
            ) {

                if (isLoading) {

                    CircularProgressIndicator(
                        modifier = Modifier.size(16.dp),
                        strokeWidth = 2.dp,
                        color = Color.White
                    )

                } else {

                    Text(
                        text = "Follow",
                        color = Color.White,
                        fontWeight = FontWeight.Bold
                    )
                }
            }
        }
    }
}